// i18n keys of the multi-tenant work package "docprefix" (en / zh / th). ⛔ Fill all three: an empty th value falls back to English.
export const en: Record<string, string> = {
  dpx_title: 'Document number prefixes',
  dpx_hint: 'What this firm’s quotation, invoice and receipt numbers start with: {prefix}-{series letter}-{year and month}{run}. Leave a field empty to use the product default shown in grey. Changing a prefix starts a new numbering series for new documents — numbers already issued keep theirs and still open their documents.',
  dpx_quotation: 'Quotation',
  dpx_invoice: 'Invoice',
  dpx_receipt: 'Receipt',
  dpx_default: 'Default: {{p}}',
  dpx_example: 'Next number looks like',
  dpx_retired: 'Earlier prefixes still recognised',
  dpx_saved: 'Saved',
  dpx_no_letter: 'Set the document series letter above first — every number needs it.',
  dpx_confirm_change: 'A new prefix starts a new numbering series for new documents. Numbers already issued are not changed. Continue?',
  dpx_merchant: 'This company sets its document numbering in the client portal.',
};
export const zh: Record<string, string> = {
  dpx_title: '单据编号前缀',
  dpx_hint: '本所报价单、发票、收据编号的开头：{前缀}-{系列字母}-{年月}{流水号}。留空 = 使用灰字显示的产品默认值。改前缀会让新单据开启新的编号系列——已开出的编号不变，点击仍能打开原单据。',
  dpx_quotation: '报价单',
  dpx_invoice: '发票',
  dpx_receipt: '收据',
  dpx_default: '默认：{{p}}',
  dpx_example: '下一个编号形如',
  dpx_retired: '仍可识别的旧前缀',
  dpx_saved: '已保存',
  dpx_no_letter: '请先在上方设置单据系列字母——每个编号都需要它。',
  dpx_confirm_change: '新前缀会让新单据开启新的编号系列，已开出的编号不会改动。继续吗？',
  dpx_merchant: '该公司在客户门户里设置自己的单据编号。',
};
export const th: Record<string, string> = {
  dpx_title: 'คำนำหน้าเลขที่เอกสาร',
  dpx_hint: 'ตัวอักษรที่ขึ้นต้นเลขที่ใบเสนอราคา ใบแจ้งหนี้ และใบเสร็จรับเงินของสำนักงานนี้: {คำนำหน้า}-{อักษรชุด}-{ปีและเดือน}{ลำดับ} เว้นว่างไว้เพื่อใช้ค่าเริ่มต้นของระบบที่แสดงเป็นสีเทา การเปลี่ยนคำนำหน้าจะเริ่มชุดเลขที่ใหม่สำหรับเอกสารใหม่ — เลขที่ที่ออกไปแล้วยังคงเดิมและยังเปิดเอกสารได้',
  dpx_quotation: 'ใบเสนอราคา',
  dpx_invoice: 'ใบแจ้งหนี้',
  dpx_receipt: 'ใบเสร็จรับเงิน',
  dpx_default: 'ค่าเริ่มต้น: {{p}}',
  dpx_example: 'เลขที่ถัดไปจะเป็นแบบ',
  dpx_retired: 'คำนำหน้าเดิมที่ระบบยังรู้จัก',
  dpx_saved: 'บันทึกแล้ว',
  dpx_no_letter: 'ตั้งอักษรชุดเอกสารด้านบนก่อน — ทุกเลขที่ต้องใช้อักษรนี้',
  dpx_confirm_change: 'คำนำหน้าใหม่จะเริ่มชุดเลขที่ใหม่สำหรับเอกสารใหม่ เลขที่ที่ออกไปแล้วจะไม่เปลี่ยน ดำเนินการต่อหรือไม่?',
  dpx_merchant: 'บริษัทนี้ตั้งเลขที่เอกสารเองในพอร์ทัลลูกค้า',
};
